module.exports = __webpack_public_path__ + "img/page.677f6dda.png";